import React from 'react';
import { LoaderWrapper, Loader } from './index.style';
import { LOADER_ICON } from '@Images';

export const FallBackLoader = () => (
  <LoaderWrapper id="loading">
    <Loader src={LOADER_ICON} />
  </LoaderWrapper>
);
